<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" size="small">
      <el-form-item prop="reviewComments">
        <el-input
          v-model="formData.reviewComments"
          :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
          type="textarea"
          :rows="6"
          maxlength="200"
          show-word-limit
          ref="reviewCommentsInput"
        />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: { hxPreOrderCode: { type: String, default: '' } },
  data() {
    return {
      formData: { reviewComments: '' },
      rules: {
        reviewComments: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.$refs.reviewCommentsInput.focus()
  },
  methods: {
    async rejected() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      const params = {
        ...this.formData,
        hxPreOrderCode: this.hxPreOrderCode,
      }

      this.loadingOpen()
      const res = await this.$api
        .ecomHxPreOrderRejectApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status, msg } = res
      if (status !== 200) {
        this.$message.error(msg)
        return
      }

      this.$message({
        showClose: true,
        message: res.msg,
        type: 'success',
      })
      this.$emit('reload')
      this.close()
    },
    cancel() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.rejected()
        })
        .catch((action) => {
          if (action === 'cancel') this.close()
        })
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
